export default {
    type: ['required'],
    restaurant: ['required'],
    value: ['required'],
};